module.exports = __webpack_public_path__ + "static/img/materials4.734e4a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materials4.jpg
// module id = zwvC
// module chunks = 1